<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>
        <v-card>
          <v-card-text>
            <v-row v-if="!!model.VlrFipe" class="text--disabled mb-4 ma-2">
              <span>Valor da Fipe:</span>
              <span class="ml-auto">R$ {{ $api.UI.Format.Decimal(model.VlrFipe)}}</span>
            </v-row>
            <v-row class="ma-2">
              <span>Valor do Veículo:</span>
              <span class="ml-auto">R$ {{ $api.UI.Format.Decimal(model.VlrProdutoBem)}}</span>
            </v-row>
            <v-row class="ma-2 mb-4">
              <span>Valor Entrada:</span>
              <span class="ml-auto">R$ -{{$api.UI.Format.Decimal(model.VlrEntrada)}}</span>
            </v-row>
            <v-row class="ma-2">
              <span class="mb-1">Outros Valores:</span>
              <span class="ml-auto">R$ {{$api.UI.Format.Decimal((model.VlrDespachante || 0) + (model.VlrSeguro || 0) + (model.VlrAcessorios || 0) + (model.VlrBlindagem || 0) + (model.VlrAvaliacao || 0))}}</span>
            </v-row>
            <v-divider />

            <v-row class="font-weight-bold ma-2 mt-3 pb-4">
              <span bold>Valor Solicitado:</span>
              <span bold class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrProdutoBem - model.VlrEntrada + (model.VlrDespachante || 0) + (model.VlrSeguro || 0) + (model.VlrAcessorios || 0) + (model.VlrBlindagem || 0) + (model.VlrAvaliacao || 0))}}</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>Valor IOF:</span>
              <span class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrIOF)}}</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>Valor TC:</span>
              <span class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrTAC)}}</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>Gravame:</span>
              <span class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrOutrosServicos)}}</span>
            </v-row>

            <v-divider />

            <v-row class="font-weight-bold mt-3 pb-3 ma-2">
              <span bold>Valor Financiado:</span>
              <span bold class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrTotalCredito)}}</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>Primeiro Vencimento:</span>
              <span class="ml-auto">{{$api.UI.Format.Date(model.DtPrimeiroVencto)}}</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>Taxa de Juros:</span>
              <span class="ml-auto">{{$api.UI.Format.Decimal(model.PercJurosMensal)}} % a.m / {{$api.UI.Format.Decimal(model.PercJurosAnual)}} % a.a</span>
            </v-row>
            <v-row class="pb-2 ma-2">
              <span>% de CET:</span>
              <span class="ml-auto">{{$api.UI.Format.Decimal(model.PercCETMensal)}} % a.m / {{$api.UI.Format.Decimal(model.PercCETAnual)}} % a.a</span>
            </v-row>
            <v-divider />

            <v-row class="font-weight-bold ma-2 mt-3 pb-4">
              <span bold>Valor do Crédito:</span>
              <span bold class="ml-auto">R$ {{$api.UI.Format.Decimal(model.VlrTotalDivida)}}</span>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    modal: { type: Boolean, default: false },
    model: { type: Object }
  },
  data () {
    return {
      isLoaded: false,
    };
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
